import { FluxType } from 'flux/buildFlux';
import { LocationInfo } from 'src/cordovaPlugins/Location';
import {
  enableLongFormKeyboard,
  enableSimpleKeyboard,
  resetKeyboard,
} from '~/cordovaPlugins/Keyboard';
import {
  askForLocationPermissionsAfterDenial,
  permissions$,
  requestHighAccuracyLocationPermission,
  requestLocationBackgroundPermission,
  requestLocationInUsePermission,
} from '~/cordovaPlugins/Permissions';

import { Keyboard } from './Device';
import { LocationService } from './LocationService';
import { OneSignalService } from './OneSignalService';
import { PushNotificationService } from './PushNotificationService';
import { AppServices, WlService } from './Service';

abstract class ServicesWithLocation extends WlService {
  protected getLocation: () => Promise<LocationInfo>;

  constructor(protected flux: FluxType) {
    super(flux);
    const { lastLocation$, getLocation } = this.start(
      'LocationService',
      LocationService,
    );
    this.location$ = lastLocation$;
    this.getLocation = getLocation;
  }
}

export class Services extends ServicesWithLocation {
  build(): AppServices {
    this.start('Keyboard', Keyboard);

    const oneSignalService = this.start('OneSignalService', OneSignalService);
    const { startPush, destroy: destroyPushNotification } = this.start(
      'PushNotificationService',
      PushNotificationService,
      {
        oneSignalService,
      },
    );

    return {
      permissions$,
      location$: this.location$,
      locationFunctions: {
        getLocation: this.getLocation,
      },
      permissionFunctions: {
        startPush,
        requestLocationBackgroundPermission,
        requestLocationInUsePermission,
        requestHighAccuracyLocationPermission,
        askForLocationPermissionsAfterDenial,
      },
      keyboard: {
        resetKeyboard,
        useLongFormKeyboard: enableLongFormKeyboard,
        useSimpleKeyboard: enableSimpleKeyboard,
      },
      destroy: () => {
        destroyPushNotification?.();
        oneSignalService?.destroy?.();
      },
    };
  }
}
